import { ReactElement, use } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import OfficeBuildingMarker from 'shared/components/icons/office-building-marker';

import WanderingBoundarySettingsProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-provider-context';
import styles from './wandering-boundary-settings-details-header.module.scss';

const WanderingBoundarySettingsDetailsHeader = (): ReactElement => {
  const { t } = useTranslation('wanderingBoundarySettings');

  const iconSx = {
    fontSize: '16px',
  };

  const {
    detailsState: { selectedLocation: currentSelectedWanderingBoundaryLocation },
  } = use(WanderingBoundarySettingsProviderContext);

  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <Typography variant="h3">{t('details.title')}</Typography>
        <div className={styles.location}>
          <OfficeBuildingMarker sx={iconSx} />
          <Typography variant="body1">{currentSelectedWanderingBoundaryLocation?.name}</Typography>
        </div>
      </div>
      <div className={styles.title}></div>
    </div>
  );
};

export default WanderingBoundarySettingsDetailsHeader;
